/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

;(function () {
    var accessibilityUpdateQueued = false

    function removeAttributeIfPresent(element, attribute) {
        if (element.hasAttribute(attribute)) {
            element.removeAttribute(attribute)
        }
    }

    function normalizeSlickAccessibility() {
        document.querySelectorAll('.slick-slider').forEach(function (slider) {
            slider.querySelectorAll('.slick-track').forEach(function (track) {
                if (track.getAttribute('role') === 'listbox') {
                    track.removeAttribute('role')
                }
            })

            slider.querySelectorAll('.slick-slide').forEach(function (slide) {
                removeAttributeIfPresent(slide, 'role')
                removeAttributeIfPresent(slide, 'aria-describedby')

                var isVisible = slide.classList.contains('slick-active')
                var hiddenValue = isVisible ? 'false' : 'true'
                if (slide.getAttribute('aria-hidden') !== hiddenValue) {
                    slide.setAttribute('aria-hidden', hiddenValue)
                }

                if (isVisible) {
                    removeAttributeIfPresent(slide, 'inert')
                } else if (!slide.hasAttribute('inert')) {
                    slide.setAttribute('inert', '')
                }
            })

            slider.querySelectorAll('.slick-dots').forEach(function (dots) {
                removeAttributeIfPresent(dots, 'role')
                var toolbar = dots.closest('[role="toolbar"]')
                if (toolbar) {
                    toolbar.removeAttribute('role')
                }

                dots.querySelectorAll('li').forEach(function (dot) {
                    removeAttributeIfPresent(dot, 'role')
                    removeAttributeIfPresent(dot, 'aria-selected')
                    removeAttributeIfPresent(dot, 'aria-controls')
                    removeAttributeIfPresent(dot, 'aria-hidden')

                    var button = dot.querySelector('button')
                    if (button) {
                        removeAttributeIfPresent(button, 'role')
                        removeAttributeIfPresent(button, 'aria-selected')
                        removeAttributeIfPresent(button, 'aria-controls')
                        if (dot.classList.contains('slick-active')) {
                            button.setAttribute('aria-current', 'true')
                        } else {
                            removeAttributeIfPresent(button, 'aria-current')
                        }
                    }
                })
            })
        })
    }

    function queueSlickAccessibilityUpdate() {
        if (accessibilityUpdateQueued) {
            return
        }
        accessibilityUpdateQueued = true
        window.requestAnimationFrame(function () {
            accessibilityUpdateQueued = false
            normalizeSlickAccessibility()
        })
    }

    document.addEventListener('DOMContentLoaded', function () {
        normalizeSlickAccessibility()
        if (!document.body) {
            return
        }

        var observer = new MutationObserver(queueSlickAccessibilityUpdate)
        observer.observe(document.body, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                'class',
                'role',
                'aria-hidden',
                'aria-selected',
                'aria-controls',
                'aria-describedby'
            ]
        })
    })
})()
